const reportingApiRoot = '/api';

export default reportingApiRoot;
